const GOOGLE_ADS_ID = "AW-18417803095";

// Fire a Google Ads / Analytics event. Silently no-ops if the tag is blocked.
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, { send_to: GOOGLE_ADS_ID, ...params });
};

export const trackPageView = (path) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("config", GOOGLE_ADS_ID, { page_path: path });
};
